import { FLAG_IMAGES } from './assets.js'

export default {
  SERVER: `${process.env.CORPORATE_URL}/`,
  VECTOR_TILE_ENDPOINT: `${process.env.CORPORATE_URL}/api/geodata/get-admin-tiles/{z}/{x}/{y}.pbf`,
  GEOSERVER: `${process.env.GEOSERVER_URL}/`,
  TOOLS_WIDTH: 250,
  ANALYSIS_HEIGHT: 340,
  BOUNDS_PADDING: 50,
  MAX_SHAPEFILE_SIZE: 1024 * 1024 * 150, // Actually allow any file less than 150MB
  BING_KEY: 'AgxmoRJM_exFmfivBMm-OKH9owUZL3j5BMHB1VhilF4NCwp9gc00Ho4qsFniJEtr',
  GOOGLE_KEY: 'AIzaSyBuecu8rf-4Wc0NVw5UCK-yqKW51Wg5NSs',
  NO_ANALYSIS: 'NO_ANALYSIS',
  MY_PROFILE_URL: `${process.env.CORPORATE_URL}/users/user-plan-detail/`,
  MY_ACCOUNT_URL: `${process.env.CORPORATE_URL}/users/user-update/`,
  SERVICE_DESK_URL: 'https://populationexplorer.atlassian.net/servicedesk/customer/portal/1',
  GOOGLE_AUTOCOMPLETE_URL: 'https://places.googleapis.com/v1/places:autocomplete',
  GOOGLE_MAPS_KEY: 'AIzaSyBuecu8rf-4Wc0NVw5UCK-yqKW51Wg5NSs',
  MAX_GEOMETRY_SIZE: 8500000,
  MULTIPOLYGON_MAX_SIZE: 8000000,
  MAX_PREVIEW_POINTS: 25000000,
  INACCURATE_BUFFER_AREA: 1000000,
  INACCURATE_BUFFER_LENGTH: 500,
  TRIAL_STATUS: 'trialing',
  ENTERPRISE_TRIAL_STATUS: 'enterprise_trial',
  ACTIVE_STATUS: 'active',
  RANGE_SLIDER_CONFIG: {
    THUMB_WIDTH: 8,
    WIDTH: 288
  }
}

export const CURRENCIES = Intl.supportedValuesOf('currency')

export const LANDSCAN_LATEST_YEAR = 2024
export const ISOCHRONE_SMOOTH_ITERATIONS = 5
export const MODE_OF_TRANSPORTATION = ['Driving', 'Driving-Traffic', 'Cycling', 'Walking']
export const TRAVEL_TIME = [10, 20, 30, 40, 50, 60]

export const strings = {
  MODE_OF_TRANSPORTATION: 'Mode of Transportation',
  TRAVEL_TIME: 'Travel Time',

  ACTIONS: 'Actions',
  ANALYSIS_INVALID:
    'This region could not be analyzed. It may be too small or too complex for analysis. Please contact customer support if this seems like an error.',
  ANALYSING_TARGET_GROUP:
    'For complex Target Groups, please expect up to 30 seconds for loading to complete.',
  ANALYSING_MARKERS_WITHIN: 'Loading markers list.',
  BULK_ACTION: 'Bulk Action',
  RADIUS_METERS: 'Radius (meters)',
  CANCEL: 'Cancel',
  OK: 'OK',
  LOGIN: 'Log in with Population Explorer account',
  LOG_OUT: 'Log Out',
  EMAIL: 'Email Address',
  PASSWORD: 'Password',
  INVALID_CREDENTIALS: 'Invalid email or password',
  MY_PROFILE: 'My profile',
  NAME: 'Name',
  DESCRIPTION: 'Description',
  RENAME: 'Rename',
  EDIT: 'Edit',
  EDIT_DESCRIPTION: 'Edit Description',
  DELETE: 'Delete',
  FIT_REGION: 'Zoom map to region',
  EXPORT_KML: 'Export KML/KMZ',
  COPY_REGION: 'Copy',
  MOVE_REGION: 'Move',
  LONGITUDE: 'Longitude',
  LATITUDE: 'Latitude',
  COLOR: 'Color',
  BUFFER: 'Buffer',
  UNIT_KM: 'km',
  UNIT_MILE: 'mile',
  SHARE: 'Share',
  UNSHARE: 'Unshare',
  BROWSE_SHAPES: 'Browse shapes in file',
  CHOOSE_DATA_SET: 'Choose layer from file',
  CHOOSE_TARGET_GROUP: 'Choose Target Group from list',
  CONFIRM_ADD: 'Add',
  CONFIRM_SAVE: 'Save',
  DUPLICATE_BOUNDARY:
    'The same boundary cannot be added twice to the same Target Group',
  CONFIRM_UPLOAD: 'Upload',
  CONFIRM_DONE: 'Done',
  UPLOAD_SHAPEFILE: 'Upload shapefile',
  UPLOAD_MARKERFILE: 'Upload Marker file',
  DELETE_SHAPEFILE: 'Delete shapefile',
  DELETE_MARKERFILE: 'Delete Marker file',
  ANALYZE_SHAPEFILES:
    'To analyze custom shapefiles, upload a Zip-compressed shapefile or a KML/KMZ file.',
  NO_SHAPEFILES: 'No shapefiles uploaded.',
  NO_MARKERFILES: 'No Marker files uploaded.',
  DUPLICATE_GROUP_NAME: 'You already have a target group with that name.',
  DUPLICATE_ELEMENT_NAME: (element) =>
    `You already have a ${element} with that name in this target group.`,
  NO_FILES: 'No files uploaded.',
  ANALYZE_MARKERFILES: 'You can upload a Marker file in csv or xlsx.',
  MARKERS_WITHIN: (targetGroup) =>
    `Markers that fall within selected geometr${targetGroup ? 'ies' : 'y'}`,
  MARKERS_WITHIN_NOT_FOUND: 'Markers not found.',
  MARKERS_WITHIN_COUNT: (count) => `Markers count: ${count}`,
  UPLOAD_SHAPEFILES: 'Upload Shapefiles in the <b>My Data</b> section.',
  UPLOAD_MARKERFILES: 'Upload marker files in the <b>My Data</b> section.',
  SHAPEFILES_ADD_SHAPE:
    'Add shapes from your shapefiles to the map using <b>Add Item</b> within a Target Group.',
  MARKERFILES_ADD_MARKER:
    'Add markers from your marker files to the map using <b>Add Item</b> within a Target Group.',
  EMPTY_SHAPE_NAME: 'Please enter a non-empty name',
  SHAPEFILE_TOO_LARGE:
    'This shapefile is too large. Please choose a shapefile less than 10MB.',
  MARKERFILE_TOO_LARGE:
    'This Marker file is too large. Please choose a XLSX/CSV file less than 10MB.',
  SHAPEFILE_NOT_ZIP:
    'Please choose a Zip-compressed shapefile or a KML/KMZ file.',
  MARKERFILE_NOT_CSV: 'Please choose a XLSX or CSV file.',
  AN_ERROR_OCCURRED:
    'An error occurred, we are looking into it. Please contact support if you need help.',
  KML_TIMEOUT:
    'Your request timed out, please try again later. Please contact support if you need help.',
  KML_FAILED:
    'An error occurred while exporting your file, we are looking into it. Please contact support if you need help.',
  TRIAL_UPLOAD_BROWSE:
    'Uploading of shapefiles and choosing from our library of boundaries are available with a paid subscription.',
  ZOOM_WHILE_PREVIEWING: 'Zoom while previewing',
  NO_PREVIEW:
    'These geometries are too complex to preview all at once. Please select a shape below to preview it.',
  GENDER_RATIO: 'Ratio of Males/Females',
  POPULATION_DATA: (
    <span>
      To learn more about our data, see <a style={{ color: '#0099FF' }} target='_blank' onClick={() => window.open(`${process.env.CORPORATE_URL}/resources/data/`, '_blank')}>PopEx Data</a>
    </span>
  ),
  METRIC: {
    AREA: (
      <span>
        km<sup>2</sup>
      </span>
    ),
    DENSITY: (
      <span>
        people / km<sup>2</sup>
      </span>
    ),
  },
  POPULATION: {
    TOTAL: 'Total',
    AVERAGE_INCOME: 'Income',
    MALE: 'Male',
    FEMALE: 'Female',
    POPULATION: 'Population',
    AREA: 'Area',
    DENSITY: 'Density',
    AGE_GENDER: 'Age/Gender breakdown',
    SUMMARY: 'Summary',
    GENDER_RATIO: 'Gender (m/f)',
    AVERAGE_AGE: 'Average Age'
  },
  MAP_SETTINGS: {
    TITLE: 'Settings',
    BASE_MAP: 'Base map',
    OVERLAYS: 'Overlays',
    POPULATION_DATA_YEAR: 'Data Year',
    POPULATION_DENSITY: 'Population density overlay',
    ZOOM_TO_SELECTED: 'Map follows selection',
    MARKER_LABELS: 'Marker labels',
  },
  MY_DATA: {
    TITLE: 'Uploads',
    SHAPEFILES: 'Shapefiles',
    MARKERFILES: 'Marker files',
  },
  TARGET_GROUP: {
    ADD: 'Add target group',
    ADD_ITEM: 'Add item',
    TARGET_GROUP: 'Target group',
    SHARED_TARGET_GROUP: 'Shared target group',
    SHARED_WITH_YOU: 'Shared with you by',
    MY_TARGET_GROUPS: 'My Data',
    SHARED_WITH_ME: 'Shared with me',
    NO_SHARED_GROUPS:
      'Any target groups which others share with you will be listed here.',
    NO_REGIONS: 'Add shapes or regions to this target group to see analysis',
  },
  WELCOME_MODAL: {
    TITLE_STARTER: 'Welcome to your Trial account!',
    TITLE_SOLO: 'Welcome to PopEx!',
    TEXT_FIRST_PARAGRAPH_STARTER: 'You have access to <b> 2016 data</b> and <b> 5 analysis areas</b>.',
    TEXT_FIRST_PARAGRAPH_SOLO: 'This is the worlds fastest and easiest market area analysis platform. Locate your next customer, client or displaced population in seconds, worldwide.',
    TEXT_SECOND_PARAGRAPH_STARTER: 'Want current population data and unlimited areas? ',
    TEXT_SECOND_PARAGRAPH_SOLO: 'Need help getting started? Watch the video below, or'
  },
  DATA_UPDATE_INFO_MODAL: {
    TITLE: 'Welcome back. We are getting things ready for you.',
    TEXT_FIRST_PARAGRAPH: 'New population data is available and we are updating your account. This might take a few minutes.',
    TEXT_SECOND_PARAGRAPH: 'This notice will close automatically when the update is complete.',
    BUTTON_TEXT: 'Contact Support'
  },
  REQUESTS_LIMIT_MODAL: {
    TITLE: 'Reached monthly quota limit',
    TEXT_FIRST_PARAGRAPH: 'You have reached your monthly quota limit based on your API subscription type.',
    TEXT_SECOND_PARAGRAPH: 'Please contact <a href="mailto:api@populationexplorer.com">api@populationexplorer.com</a> to requested additional details about your usage, or upgrade your API subscription type <b>here</b>.',
  },
  ITEM: {
    ADD: 'Add item',
    EDIT: 'Edit item',
    MARKER: 'Add marker',
    EDIT_MARKER: 'Edit marker',
    MARKER_START: 'Click on the map to place the marker.',
    LINE: 'Buffer around line',
    POINT: 'Buffer around point',
    ISOCHRONE: 'Isochrone',
    POINT_START: 'Click on the map to place the point.',
    DRAW_SHAPE: 'Draw shape',
    MY_SHAPEFILES: 'My shapefiles',
    MY_SHAPEFILE: 'My shapefile',
    MY_MARKERFILES: 'My marker files',
    MY_MARKERFILE: 'My marker file',
    MY_MARKERFILE_MARKERS: 'My marker file markers',
    BOUNDARY: 'Choose boundary',
    DRAW_SHAPE_START: 'Click on the map to start the shape.',
    DRAW_SHAPE_CONTINUE:
      'Continue adding points, then click the initial point to close the shape.',
    DRAW_LINE_START: 'Click on the map to start the line.',
    DRAW_LINE_CONTINUE:
      'Continue adding points, then double-click to complete the line.',
    COMPLETE_LINE: 'Finish drawing line',
    COMPLETE_EDIT: 'Edit drawing line',
    GEOMETRY_TOO_LARGE:
      'User shapes are currently limited to 8.5 million square kilometers. Please click Cancel to draw a new shape.',
    LARGE_BUFFER_INACCURACY:
      'Very large buffered shapes will be somewhat distorted due to the curvature of the earth.',
    EDIT_SHAPE: 'Edit shape',
    EDIT_POINT_BUFFER: 'Edit point buffer',
    EDIT_LINE_BUFFER: 'Edit line buffer',
    EDIT_POINT: 'Edit point',
    EDIT_LINE: 'Edit line',
    EDIT_ISOCHRONE: 'Edit Isochrone',
    BULK_BUFFER: 'Bulk Buffer',
    BULK_BUFFER_TITLE: 'Bulk Buffer Markers',
    BULK_BUFFER_DESC: 'Create a circular ring around every marker in this folder.',
    BULK_TRAVEL_TIME: 'Bulk Travel Time',
    BULK_TRAVEL_TIME_TITLE: 'Bulk Travel Time',
    BULK_TRAVEL_TIME_DESC: 'Create travel-time polygons for every marker in this folder.',
  },
  GEOPOLYGON: {
    GEOPOLYGON: 'Region',
  },
  BOUNDARY: {
    BOUNDARY: 'Boundary',
    SEARCH: 'Search',
    BROWSE: 'Browse',
  },
  MARKER: {
    MARKER: 'Marker',
  },
  USER: {
    USER: 'Account',
  },
  INVALID: {
    REQUIRED: 'This is a required field',
    AT_LEAST_1: 'This value must be at least 1',
  },
}

export const errorDetails = {
  EXPIRED: 'Your subscription is expired',
  EXPIRED_24_TRIAL: 'Your 24 hours trial subscription is expired.',
}
export const limitErrorMessage = {
  TITLE_FREE_USER: 'Free limit reached',
  TITLE_PRO_USER: 'You have reached the maximum allowable items',
  BUTTON_TEXT: 'Please upgrade to unlock this feature',
}
export const templates = {
  TARGET_GROUP_NAME: (name) => `Target Group ${name}`,
}

export const selectionTypes = {
  TARGET_GROUP: 'TARGET_GROUP',
  NEW_TARGET_GROUP: 'NEW_TARGET_GROUP',
  GEOPOLYGON: 'GEOPOLYGON',
  POINT_BUFFER: 'POINT_BUFFER',
  SHAPE: 'SHAPE',
  LINE: 'LINE',
  MARKER: 'MARKER',
  SAVED_MARKER: 'SAVED_MARKER',
  BOUNDARY_LIST: 'BOUNDARY_LIST',
  BOUNDARY: 'BOUNDARY',
  USER_SHAPEFILE_LIST: 'USER_SHAPEFILE_LIST',
  USER_MARKERFILE_LIST: 'USER_MARKERFILE_LIST',
  NEW_ITEM: 'NEW_ITEM',
  USER: 'USER',
  NONE: 'NONE',
  ISOCHRONE: 'ISOCHRONE',
  COLOR: 'COLOR',
  BULK_POINT_BUFFER: 'BULK_POINT_BUFFER',
  BULK_ISOCHRONE: 'BULK_ISOCHRONE',
  MULTI_ITEMS: 'MULTI_ITEMS',
  ZIP_CODE_BOUNDARY: 'ZIP_CODE_BOUNDARY'
}

export const typeLabels = {
  GEOPOLYGON: 'Geopolygon',
  BOUNDARY: 'Boundary',
  ZIP_CODE_BOUNDARY: 'Boundary',
  MARKER: 'Marker',
  TARGET_GROUP: 'Folder'
}

export const keyCodes = {
  ARROW_LEFT: 'ArrowLeft',
  ARROW_UP: 'ArrowUp',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_DOWN: 'ArrowDown',
}

export const MAPBOX_API_KEY = 'pk.eyJ1IjoibXRheXlhYm1pciIsImEiOiJjbDZuaWQ5Z3QwMTNyM2tsbGs2emtlc21uIn0.cwMj_2X3NoUdcbWnLGiG4g'

export const ageBuckets = new Map([
  ['0_4', '0-4'],
  ['5_9', '5-9'],
  ['10_14', '10-14'],
  ['15_19', '15-19'],
  ['20_24', '20-24'],
  ['25_29', '25-29'],
  ['30_34', '30-34'],
  ['35_39', '35-39'],
  ['40_44', '40-44'],
  ['45_49', '45-49'],
  ['50_54', '50-54'],
  ['55_59', '55-59'],
  ['60_64', '60-64'],
  ['65_69', '65-69'],
  ['70_74', '70-74'],
  ['75_79', '75-79'],
  ['80plus', '80+'],
])

export const genderLabels = new Map([
  ['total', 'Total'],
  ['female', 'Female'],
  ['male', 'Male'],
])

export const asyncStatuses = {
  PROCESSING: 'Processing',
  FAILED: 'Failed',
  NOT_CALCULATED: 'not_calculated',
}

export const DOCUMENT_EVENTS = {
  keyup: 'documentKeyup',
  keydown: 'documentKeydown',
  dblclick: 'documentDblclick',
}

export const shapeTypes = {
  DRAWN_SHAPE: 'drawn_shape',
  POINT_BUFFER_SHAPE: 'point_buffer_shape',
  LINE_BUFFER_SHAPE: 'line_buffer_shape',
  ISOCHRONE_SHAPE: 'isochrone_shape'
}

export const languages = [
  {
    NAME: 'English',
    FLAG: FLAG_IMAGES.US,
    COUNTRY_CODE: 'en'
  },
  {
    NAME: 'Spanish',
    FLAG: FLAG_IMAGES.ES,
    COUNTRY_CODE: 'es'
  },
  {
    NAME: 'Mandarin',
    FLAG: FLAG_IMAGES.CN,
    COUNTRY_CODE: 'zh'
  },
  {
    NAME: 'Hindi',
    FLAG: FLAG_IMAGES.HI,
    COUNTRY_CODE: 'hi'
  },
  {
    NAME: 'French',
    FLAG: FLAG_IMAGES.FR,
    COUNTRY_CODE: 'fr'
  },
  {
    NAME: 'Arabic',
    FLAG: FLAG_IMAGES.JO,
    COUNTRY_CODE: 'ar'
  }
]

export const layerTypes = {
  satelite: ['googleSatellite', 'googleHybrid'],
  terrain: ['googleTerrain', 'googleRoadmap', 'openStreet']
}

export const SORT_TYPES = {
  ASC: 'ASC',
  DESC: 'DESC',
  MODIFIED: 'MODIFIED'
}

export const FILTER_SETTINGS = {
  MAP_ITEM_TYPES: {
    ALL: 'All',
    GEOPOLYGON: 'Geopolygon',
    MARKER: 'Marker',
    BOUNDARY: 'Boundary'
  }
}

export const defaultPolygonColor = '#808080'

export const defaultMarkerColor = '#808080'

export const selectedShapeFillColor = '#fffcfcfc'

export const filterSelectThemeColor = '#33354D'

export const PLACES_REQUEST_FIELDS = ['id', 'displayName', 'location', 'businessStatus', 'formattedAddress', 'types', 'iconMaskBaseUri']

// Shape of `additional_info` item.input per field type. Used both to build a fresh item when
// adding one (FieldTypeSelect) and to reset an item's input when its type is changed, since
// the previous type's input keys/values (e.g. a currency amount) don't carry meaning under a
// different type.
export const ADDITIONAL_INFO_DEFAULT_INPUT = {
  date: { value: null, title: null },
  currency: { value: null, currency: null, title: null },
  number: { value: null, title: null },
  text: { value: null, title: null }
}

export const bufferArountPoint = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_12780_8837)">
<g clip-path="url(#clip1_12780_8837)">
<path d="M7.4387 16.8477C7.94367 16.9476 8.46572 17 9 17C9.53428 17 10.0563 16.9476 10.5613 16.8477M4.55507 15.6525C3.68266 15.0685 2.93154 14.3173 2.34747 13.4449M1.15227 10.5613C1.05238 10.0563 1 9.53428 1 9C1 8.46572 1.05238 7.94367 1.15227 7.4387M2.34748 4.55507C2.93154 3.68266 3.68266 2.93154 4.55507 2.34748M7.4387 1.15227C7.94367 1.05238 8.46572 1 9 1C9.53428 1 10.0563 1.05238 10.5613 1.15227M13.4449 2.34747C14.3173 2.93154 15.0685 3.68266 15.6525 4.55507M16.8477 7.4387C16.9476 7.94367 17 8.46572 17 9C17 9.53428 16.9476 10.0563 16.8477 10.5613M15.6525 13.4449C15.0685 14.3173 14.3173 15.0685 13.4449 15.6525" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M8.99954 11.6709C10.4749 11.6709 11.671 10.4749 11.671 8.99954C11.671 7.52416 10.4749 6.32812 8.99954 6.32812C7.52416 6.32812 6.32812 7.52416 6.32812 8.99954C6.32812 10.4749 7.52416 11.6709 8.99954 11.6709Z" fill="#33354D"/>
</g>
</g>
<defs>
<clipPath id="clip0_12780_8837">
<rect width="18" height="18" fill="white"/>
</clipPath>
<clipPath id="clip1_12780_8837">
<rect width="17" height="17" fill="white" transform="translate(0.5 0.5)"/>
</clipPath>
</defs>
</svg>
`
export const bufferAroundPoint = bufferArountPoint

export const travelTime = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_12780_8848)">
<g clip-path="url(#clip1_12780_8848)">
<path d="M9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17C13.4183 17 17 13.4183 17 9M9 13V9L14.5 4" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M9 10C9.55228 10 10 9.55228 10 9C10 8.44772 9.55228 8 9 8C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10Z" fill="#33354D"/>
</g>
</g>
<defs>
<clipPath id="clip0_12780_8848">
<rect width="18" height="18" fill="white"/>
</clipPath>
<clipPath id="clip1_12780_8848">
<rect width="17" height="17" fill="white" transform="translate(0.5 0.5)"/>
</clipPath>
</defs>
</svg>
`

export const drawShape = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 7L11 4L19 8L17 18L8 20L4 13L5 7Z" stroke-linejoin="round" stroke="#33354D"/>
<path d="M5 8.5C5.82843 8.5 6.5 7.82843 6.5 7C6.5 6.17157 5.82843 5.5 5 5.5C4.17157 5.5 3.5 6.17157 3.5 7C3.5 7.82843 4.17157 8.5 5 8.5Z" fill="white" stroke="#33354D"/>
<path d="M19 9.5C19.8284 9.5 20.5 8.82843 20.5 8C20.5 7.17157 19.8284 6.5 19 6.5C18.1716 6.5 17.5 7.17157 17.5 8C17.5 8.82843 18.1716 9.5 19 9.5Z" fill="white" stroke="#33354D"/>
<path d="M8 21.5C8.82843 21.5 9.5 20.8284 9.5 20C9.5 19.1716 8.82843 18.5 8 18.5C7.17157 18.5 6.5 19.1716 6.5 20C6.5 20.8284 7.17157 21.5 8 21.5Z" fill="white" stroke="#33354D"/>
</svg>
`

export const bufferArountLine = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 17C7 17 7 8 11 8C15 8 14 15 20 12" stroke-linecap="round" stroke="#33354D"/>
<path d="M4 18.5C4.82843 18.5 5.5 17.8284 5.5 17C5.5 16.1716 4.82843 15.5 4 15.5C3.17157 15.5 2.5 16.1716 2.5 17C2.5 17.8284 3.17157 18.5 4 18.5Z" fill="white" stroke="#33354D"/>
<path d="M11 9.5C11.8284 9.5 12.5 8.82843 12.5 8C12.5 7.17157 11.8284 6.5 11 6.5C10.1716 6.5 9.5 7.17157 9.5 8C9.5 8.82843 10.1716 9.5 11 9.5Z" fill="white" stroke="#33354D"/>
<path d="M20 13.5C20.8284 13.5 21.5 12.8284 21.5 12C21.5 11.1716 20.8284 10.5 20 10.5C19.1716 10.5 18.5 11.1716 18.5 12C18.5 12.8284 19.1716 13.5 20 13.5Z" fill="white" stroke="#33354D"/>
</svg>
`
export const bufferAroundLine = bufferArountLine

export const placeAMarker = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 21C12 21 18 15.8 18 10.5C18 7.19 15.31 4.5 12 4.5C8.69 4.5 6 7.19 6 10.5C6 15.8 12 21 12 21Z" stroke-linejoin="round" stroke="#33354D"/>
<path d="M14.25 10.5C14.25 11.7426 13.2426 12.75 12 12.75C10.7574 12.75 9.75 11.7426 9.75 10.5C9.75 9.25736 10.7574 8.25 12 8.25C13.2426 8.25 14.25 9.25736 14.25 10.5Z" stroke="#33354D"/>
</svg>`

export const placeAdministrativeBoundary = `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_12780_8892)">
<path d="M0.5 5.62305H4.4197" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M0.5 9.56738H4.4197" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M0.5 13.5117H4.4197" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M14.5592 18.7694C17.8398 18.7694 20.4993 16.124 20.4993 12.8608C20.4993 9.59753 17.8398 6.95215 14.5592 6.95215C11.2786 6.95215 8.61914 9.59753 8.61914 12.8608C8.61914 16.124 11.2786 18.7694 14.5592 18.7694Z" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M8.61914 12.8604H20.4993" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M15.1563 7.93739C15.127 7.90639 15.0976 7.87539 15.0683 7.84257C14.8098 7.56719 14.3148 7.56902 14.0544 7.84257C11.3833 10.6492 11.4034 15.0679 14.0544 17.8781C14.3129 18.1517 14.8098 18.1535 15.0683 17.8781C17.6973 15.0606 17.7156 10.8024 15.1563 7.93739Z" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M6.9879 18.6344H5.49188C3.6897 18.6344 2.22852 17.1809 2.22852 15.3883V3.7461C2.22852 1.95345 3.6897 0.5 5.49188 0.5H13.4028C15.2049 0.5 16.6661 1.95345 16.6661 3.7461" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
</g>
<defs>
<clipPath id="clip0_12780_8892">
<rect width="21" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
`

export const uploadedShapeFiles = `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_12780_8902)">
<path d="M15.5165 8.95V3.3173C15.5165 1.76062 14.2559 0.5 12.6992 0.5" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M0.894531 9.5441H5.94466C7.28934 9.5441 8.37806 8.45347 8.37806 7.11071V1.10938" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M15.5167 3.3173C15.5167 1.76062 14.2561 0.5 12.6994 0.5H9.2537C8.8163 0.5 8.39036 0.601232 8.00836 0.790325C7.6741 0.954589 7.37422 1.1857 7.12401 1.47221L1.18761 8.32733C0.744484 8.83922 0.5 9.49436 0.5 10.1724V13.9142" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M0.5 12.9453V15.7702C0.5 17.3269 1.76062 18.5876 3.3173 18.5876" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M17.6309 13.0811V18.3719H20.4997" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M11.1328 13.0811V18.4178" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M11.1328 13.0811L13.3694 17.9269" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M15.6191 13.0811V18.4178" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M15.6194 13.0811L13.3828 17.9269" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M6.43359 13.0811V18.4178" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M9.26527 13.0811L6.47852 15.866" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M9.26576 18.4376L6.58789 15.7598" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
</g>
<defs>
<clipPath id="clip0_12780_8902">
<rect width="21" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
`

export const uploadedMarkers = `<svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_12780_8923)">
<path d="M0.871094 9.02372H5.81405C7.08129 9.02372 8.10733 7.99589 8.10733 6.73045V0.78125" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M14.6521 7.02521V3.15509C14.6521 1.68804 13.464 0.5 11.997 0.5H8.74967C7.97925 0.5 7.24662 0.834811 6.7426 1.41623L1.14802 7.87664C0.730407 8.35906 0.5 8.97648 0.5 9.6155V14.8897C0.5 16.3567 1.68804 17.5448 3.15509 17.5448H7.57603" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
<path d="M14.7539 13.7793C14.7539 14.4993 14.1702 15.083 13.4502 15.083C12.7302 15.083 12.1465 14.4993 12.1465 13.7793C12.1465 13.0593 12.7302 12.4756 13.4502 12.4756C14.1702 12.4756 14.7539 13.0593 14.7539 13.7793Z" stroke="#33354D"/>
<path d="M17.3115 11.6317C16.5447 10.2834 15.1136 9.47344 13.5854 9.39783C13.5386 9.39243 13.4918 9.39062 13.4432 9.39062C10.5919 9.39062 8.54157 12.0817 9.09418 14.825C9.25439 15.6206 9.681 16.2578 10.1418 16.8968C10.5883 17.5143 11.0329 18.1317 11.4793 18.7473C11.7745 19.1559 12.0553 19.5825 12.3721 19.9749C13.0399 20.7976 14.0696 20.587 14.6456 19.8057C14.7662 19.6419 14.885 19.4745 15.0038 19.3089C15.7382 18.2919 16.5303 17.2983 17.2125 16.2452C18.0981 14.8772 18.1107 13.0375 17.3115 11.6317Z" stroke-linecap="round" stroke-linejoin="round" stroke="#33354D"/>
</g>
<defs>
<clipPath id="clip0_12780_8923">
<rect width="19" height="21" fill="white"/>
</clipPath>
</defs>
</svg>
`

export const folderActions = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.5 13.5C8.5 13.5 12.5 9.25 12.5 6.5C12.5 4.29086 10.7091 2.5 8.5 2.5C6.29086 2.5 4.5 4.29086 4.5 6.5C4.5 9.25 8.5 13.5 8.5 13.5Z" stroke-linecap="round" stroke-linejoin="round" stroke="#292C44"/>
<path d="M9.75 6.5C9.75 7.19036 9.19036 7.75 8.5 7.75C7.80964 7.75 7.25 7.19036 7.25 6.5C7.25 5.80964 7.80964 5.25 8.5 5.25C9.19036 5.25 9.75 5.80964 9.75 6.5Z" stroke="#292C44"/>
<path d="M15.5 21.5C15.5 21.5 19.5 17.25 19.5 14.5C19.5 12.2909 17.7091 10.5 15.5 10.5C13.2909 10.5 11.5 12.2909 11.5 14.5C11.5 17.25 15.5 21.5 15.5 21.5Z" stroke-linecap="round" stroke-linejoin="round" stroke="#292C44"/>
<path d="M16.75 14.5C16.75 15.1904 16.1904 15.75 15.5 15.75C14.8096 15.75 14.25 15.1904 14.25 14.5C14.25 13.8096 14.8096 13.25 15.5 13.25C16.1904 13.25 16.75 13.8096 16.75 14.5Z" stroke="#292C44"/>
</svg>
`
